import routes from "actions/routes";
import { generateReadActionCreator } from "actions/crudActionCreators";
import ACTION_NAMES from "actions/ACTION_NAMES";

export default {
    getCampaignCategoryOptions: generateReadActionCreator(routes.API_CAMPAIGN_CATEGORIES, ACTION_NAMES.CAMPAIGN_CATEGORY_OPTIONS)
}
